import { INTERNAL_MESSAGE_ALLOWED_SOURCE } from '../constants';

export const isInternalMessageSource = (
    value: unknown
): value is typeof INTERNAL_MESSAGE_ALLOWED_SOURCE =>
    value === INTERNAL_MESSAGE_ALLOWED_SOURCE;
